import React from "react";
import theme from "../../../styles/theme";



const Page34 = () => {
  return (

    <div>
    <h2>"Page 34" </h2>
    </div>

  );
};

export default Page34;
